import { Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import ProductCard from "../components/ProductCard";
import { Heart } from "@phosphor-icons/react";

export default function WishlistPage() {
  const { wishlist } = useCart();
  const { user } = useAuth();

  if (!user || user === false) {
    return (
      <div className="min-h-screen pt-28 pb-24 px-6 lg:px-12 max-w-7xl mx-auto flex flex-col items-center justify-center" data-testid="wishlist-page-login">
        <Heart size={48} weight="thin" className="text-[#A1A1AA] mb-6" />
        <h1 className="font-['Cormorant_Garamond'] text-3xl font-light text-[#FDFBF7] mb-4">Save Your Favorites</h1>
        <p className="text-[#A1A1AA] text-sm font-light mb-8">Sign in to create your wishlist.</p>
        <Link to="/auth" className="bg-[#D4AF37] text-black px-10 py-4 text-sm tracking-[0.15em] uppercase font-medium hover:bg-[#E5C158] transition-colors duration-300" data-testid="wishlist-login-btn">
          Sign In
        </Link>
      </div>
    );
  }

  if (wishlist.length === 0) {
    return (
      <div className="min-h-screen pt-28 pb-24 px-6 lg:px-12 max-w-7xl mx-auto flex flex-col items-center justify-center" data-testid="wishlist-page-empty">
        <Heart size={48} weight="thin" className="text-[#A1A1AA] mb-6" />
        <h1 className="font-['Cormorant_Garamond'] text-3xl font-light text-[#FDFBF7] mb-4">Your Wishlist is Empty</h1>
        <p className="text-[#A1A1AA] text-sm font-light mb-8">Browse our collection and save your favorites.</p>
        <Link to="/shop" className="bg-[#D4AF37] text-black px-10 py-4 text-sm tracking-[0.15em] uppercase font-medium hover:bg-[#E5C158] transition-colors duration-300" data-testid="wishlist-shop-btn">
          Shop Now
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-28 pb-24 px-6 lg:px-12 max-w-7xl mx-auto" data-testid="wishlist-page">
      <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-3 font-medium">Your Favorites</p>
      <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light text-[#FDFBF7] tracking-tighter mb-12">
        Wishlist
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {wishlist.map((product, idx) => (
          <ProductCard key={product.id} product={product} index={idx} />
        ))}
      </div>
    </div>
  );
}
